import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './ExpiredLink.css';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const ExpiredLink = () => {


  return (
    <>
      <div className="home-container">
        <Navbar />

        <div className="expired-container">
          <div className='expired-image'>
            <DotLottieReact
                src="/assets/cross-mark.json"
                loop
                autoplay
                className='cross-mark'
            />
            <img src="/assets/expird_image.svg" alt='cross-mark' />
          </div>
          <div className='expired-content'>
            <p>This verification link is broken or expired. click “Send link” to verify your account.</p>
            <button>Send Link</button>
          </div>
          
        </div>

        <Footer/>
      </div>
    </>
  );
};

export default ExpiredLink;